import type { FaireProductEntity } from "../../entity_types/product";

export const p_n38k9wpmaj: FaireProductEntity = {
  token: "p_n38k9wpmaj",
  type: "product",
  name: "MushMeez Taba Squishies Assortment - 24 pc Assortment",
  brandToken: "b_6kpudxeffr",
  brandName: "Beverly Hills Teddy Bear Company",
  imageUrl:
    "https://cdn.faire.com/fastly/10cf7a39a8c62da27f02276bd8fa077397b697b9f0e154cc2a5921e134eccc30.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/01770594396454ad5a08474036429acb9876435485255b8bd3c6ecf41816d275.jpeg",
    "https://cdn.faire.com/fastly/07d03c28e4096f6be1ab958e6939d26f5eab2531b82f2e0c2a3d0b1ab12d4a32.jpeg",
    "https://cdn.faire.com/fastly/1906d6723226a1bf90f54404ea83da5e88bb76efcd118699dcd11f7957bc857f.jpeg",
    "https://cdn.faire.com/fastly/a784cdb657751ffa2ad454475e2f42032cca7691158092b95078126f7a607bb7.jpeg",
    "https://cdn.faire.com/fastly/f761ee3241548175254dad6fe382e5485b0d8b78251b096ac968380430a93495.jpeg",
    "https://cdn.faire.com/fastly/3601f6e812fda23043fc266cb145b3de33bb9abf925195f283402149bfdaeb1d.jpeg",
    "https://cdn.faire.com/fastly/987c53911750add8e88667864de9cecc0fa3e6d9b6f29e567adf5098550557b3.jpeg",
    "https://cdn.faire.com/fastly/db727a788fd0ec652e176c698377c6fb9fe058bff722aecdaaa47d1ce61dc696.jpeg",
    "https://cdn.faire.com/fastly/21b9ced09f104603d2363c1432015a477029d2057a2438cbc67908fdcc532ff0.jpeg",
    "https://cdn.faire.com/fastly/b53c511cdd9a740f8db0ac3aca5d8ac0fc62f2538590263c6b7d5bb846d3f270.png",
    "https://cdn.faire.com/fastly/0a5f466ef5c82b1864948dda72bd35ad6f97e6c77dbd65c4e4ca6efd73437240.png",
    "https://cdn.faire.com/fastly/9b6a9db0a04ffa9ead4d10dce80636bc51c66083709be78b86ffccfde4db9923.png",
    "https://cdn.faire.com/fastly/df23f99d0352a266f0a2a72ab3cc226875440e5b1617b4da84bcf283b57e7b7b.png",
    "https://cdn.faire.com/fastly/fc92afa97a6cdb6d6e584d45684d81502338b4d2ab4163bc71b9f0dc7807cc99.png",
    "https://cdn.faire.com/fastly/7e895315936588f34922f82cba400e4ac25dfe24f6622d995977ee1906454036.png",
    "https://cdn.faire.com/fastly/1f8a44b643b86cb9db85f0bafc4f862b98a91ed5cc32c943786d6c9c4e27de46.png",
  ],
  priceDollars: 120,
  description:
    "Introducing the trending MushMeez Jumbo Taba Squishies! Each bestselling pack contains one food-themed squishy featuring revolutionary peel-apart design. These viral sensation oversized sensory toys combine squish satisfaction with stretchy slime fun without mess! 30% larger for maximum enjoyment.\n\n• Jumbo-Sized Fun: Extra-large design provides more squishing, stretching, and peeling enjoyment\n• Peel-Apart Layers: Unique multi-layer construction lets you peel and rebuild endlessly\n• Mess-Free Play: Sticky yet clean texture won't leave residue on hands or surfaces\n• Easy Maintenance: Simple soap and water cleanup keeps your squishy fresh\n• Viral Sensation: As featured on TikTok and Instagram - the hottest new sensory toy!\n\nPerfect for stress relief seekers, fidget toy enthusiasts, sensory-sensitive individuals, and children ages 6+! Great for back to school desk toys, classroom focus tools, holiday gifting, or therapeutic relaxation. This must-have fidget toy satisfies every squish craving - grab yours today!",
  tags: [],
  msrpDollars: 240,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:47:38.496Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
